import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const PricingSettingsNavigationIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox={'0 0 24 25'} {...props}>
    <path
      d={'M4.47363 10.4521L6.78906 10.4209V23.1582H4.47363V24.3164H3.31543V23.1582H1V10.4209H3.31543V6.94727H4.47363V10.4521ZM12.5781 2.31641H14.8936V20.8428H12.5781V24.3164H11.4199V20.8428H9.10449V2.31641H11.4199V0H12.5781V2.31641ZM2.1582 22H5.63184V11.5791H2.1582V22ZM10.2627 19.6846H13.7363V3.47363H10.2627V19.6846ZM20.6846 0V3.47363H23V15.0527H20.6846V18.5264H19.5264V15.0527H17.2109V3.47363H19.5264V0H20.6846ZM18.3691 4.63184V13.8945H21.8428V4.63184H18.3691Z'}
      fill={'currentColor'}
    />
  </SvgIcon>
);
